import r from "./index321.js";
import { resolveComponent as o, createBlock as s, openBlock as n } from "vue";
import i from "./index231.js";
function p(e, c, _, a, m, l) {
  const t = o("ms-ad-place");
  return n(), s(t, {
    placementId: "p8",
    height: e.getMaxHeight(),
    isInDisturber: e.isInDisturber
  }, null, 8, ["height", "isInDisturber"]);
}
const h = /* @__PURE__ */ i(r, [["render", p]]);
export {
  h as default
};
